var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white",
    fillOpacity: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9303 19.9271C22.4403 19.9271 24.4755 17.8911 24.4755 15.3811C24.4755 12.8703 22.4403 10.8359 19.9303 10.8359C17.4195 10.8359 15.3843 12.8703 15.3843 15.3811C15.3758 17.8826 17.3974 19.9186 19.8981 19.9271H19.9303Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8364 25.8359C10.8364 23.8271 12.4643 22.1992 14.4731 22.1992H25.3822C27.3901 22.1992 29.018 23.8271 29.018 25.8359V29.0174H10.8364V25.8359Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccountIcon);
export default __webpack_public_path__ + "static/media/UserAccountIcon.2eb563bcf0f0e57fd4c0199913c4be5a.svg";
export { ForwardRef as ReactComponent };